import React from 'react';
import { Wrapper, BackgroundImage, IntegrationImage, Content } from './styles';
import { Title, Text } from 'components';

export default function HowItWorks() {
  return (
    <Wrapper>
      <Content>
        <Title>Como funciona?</Title>
        <Text>
          Integramos o ecossistema de saúde por meio da prescrição eletrônica
        </Text>
      </Content>
      <BackgroundImage
        alt=""
        className="desktop"
        src={require('assets/como-funciona-bg.jpg')}
      />
      <IntegrationImage
        alt=""
        className="desktop"
        src={require('assets/como-funciona-integracao.svg')}
      />
      <IntegrationImage
        alt=""
        className="mobile"
        src={require('assets/como-funciona-integracao-mobile.svg')}
      />
    </Wrapper>
  );
}
